// src/app/components/newsletter/useNewsletterSubscription.js
import { useCallback, useEffect, useRef, useState } from "react";
import { subscribeToNewsletter } from "./newsletterService";

/**
 * État du formulaire d'abonnement : "idle" | "loading" | "success" | "error".
 * `errorCode` reprend le code de NewsletterError pour choisir le message.
 */
export default function useNewsletterSubscription() {
  const [status, setStatus] = useState("idle");
  const [errorCode, setErrorCode] = useState(null);
  const mounted = useRef(true);

  useEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );

  const subscribe = useCallback(async (email) => {
    setStatus("loading");
    setErrorCode(null);
    try {
      await subscribeToNewsletter(email);
      if (mounted.current) setStatus("success");
      return true;
    } catch (error) {
      if (mounted.current) {
        setErrorCode(error?.code || "unknown");
        setStatus("error");
      }
      return false;
    }
  }, []);

  /* L'utilisateur corrige son adresse : on efface l'erreur affichée. */
  const reset = useCallback(() => {
    setStatus((s) => (s === "loading" ? s : "idle"));
    setErrorCode(null);
  }, []);

  return { status, errorCode, subscribe, reset };
}
